// frontend/src/components/CoursesSection.jsx
import React from "react";

const coursesData = [
  {
    id: 1,
    title: "Automatic Driving Course",
    description:
      "Are you looking for Automatic Driving Lessons? Contact us anytime for further information or to schedule your first lesson.",
    image: "/img/course-3.jpg",
    link: "#contact",
  },
  {
    id: 2,
    title: "Intensive Driving Course",
    description:
      "An intensive driving course covers the whole spectrum of learning and is the best option if you need to pass your driving test quickly.",
    image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70",
    link: "#contact",
  },
  {
    id: 3,
    title: "Manual Driving Course",
    description:
      "You might be a bit nervous about starting with a manual car, but we'll cover all you need to know, and you'll be confident and consistent in no time.",
    image: "/img/course-5.avif",
    link: "#contact",
  },
  {
    id: 4,
    title: "Motorway Driving Course",
    description:
      "Our Motorway Driving Lessons are taught by authorised driving instructors registered with the Driver and Vehicle Standards Agency.",
    image: "/img/course-2.jpg",
    link: "#contact",
  },
  {
    id: 5,
    title: "Short Notice Test",
    description:
      "You have prior experience with driving lessons, so instead of booking another course, a Short Notice Driving Test course may be all you required.",
    image: "/img/course-1.jpg",
    link: "#contact",
  },
  {
    id: 6,
    title: "Pass Plus Driving Course",
    description:
      "After passing your test, you can enrol in the Pass Plus Course. It is specially designed to enhance your confidence.",
    image: "/img/course-4.jpg",
    link: "#contact",
  },
  {
    id: 7,
    title: "UK Familiarisation Course",
    description:
      "Are you a new driver who has just moved to the UK? we provide a UK Familiarisation Driving Course for drivers who are new to the UK",
    image: "/img/card-7.avif",
    link: "#contact",
  },
  {
    id: 8,
    title: "Refresher Driving Course",
    description:
      "We can tailor Refresher lessons to your specific needs, whether you want to broaden your knowledge or you're simply a little rusty.",
    image: "/img/course-8.avif",
    link: "#contact",
  },
  {
    id: 9,
    title: "Block Bookings",
    description:
      "Book and pay in full upfront to take advantage of our block booking discounts.",
    image: "/img/card-09.avif",
    link: "#contact",
  },
];

const CoursesSection = () => {
  return (
    <section
      id="courses"
      className="py-12 sm:py-16 md:py-20 px-4 sm:px-8 md:px-16 bg-[#F3F4F6]"
    >
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-center mb-8 sm:mb-12 md:mb-16 text-[#1D4ED8]">
        Driving Courses
      </h2>
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
        {coursesData.map((course) => (
          <div
            key={course.id}
            className="course-card bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-500 hover:shadow-2xl hover:-translate-y-1 hover:scale-105"
          >
            <img
              src={course.image}
              alt={course.title}
              className="w-full h-48 sm:h-56 md:h-64 object-cover"
            />
            <div className="p-4 sm:p-5 md:p-6">
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-[#1F2937]">
                {course.title}
              </h3>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 mt-2 sm:mt-3">
                {course.description}
              </p>
              <div className="flex items-center justify-between mt-4 sm:mt-5">
                <a
                  href={course.link}
                  className="py-1.5 sm:py-2 px-3 sm:px-4 bg-[#1D4ED8] hover:bg-[#1E40AF] text-white rounded-md transition"
                >
                  Book Now
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CoursesSection;
